import { useIsAutoCegidIntegrationEnabled } from '../../../hooks/useIsAutoCegidIntegrationEnabled'
import { useImportedInvoiceReviewFeature } from './useImportedInvoiceReviewFeature'

interface UseImportedInvoicesFeatureResult {
  isEnabled: boolean
}

/**
 * Gates the imported-invoices surface (nav + page). On for Cegid auto-integration
 * orgs, or when the review labs flag is on so the list can be reached without a
 * Cegid org.
 *
 * Eligibility mirrors billy-api's `CegidIntegrationGuard::isAutoIntegrationEnabled`
 * (Cegid orgs with `automaticCegidIntegration` not explicitly disabled).
 */
export const useImportedInvoicesFeature = (): UseImportedInvoicesFeatureResult => {
  const { isEnabled: isReviewEnabled } = useImportedInvoiceReviewFeature()
  const { isAutoCegidIntegrationEnabled } = useIsAutoCegidIntegrationEnabled()

  return { isEnabled: isAutoCegidIntegrationEnabled || isReviewEnabled }
}
